//basic
import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../functions/api';

//custom components
import CustomTable from '../../components/complex/customTable';
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';

import ChangeSiblingsPositions from './ChangeSiblingsPositions/ChangeSiblingsPositions';
import AddEditItem from './AddEditItem/AddEditItem';
import DeleteDialog from '../../components/global/deleteDialog';



//material-ui
import { CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

//style
import './Banner.scss';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import removeAccents from 'remove-accents';

const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiInput: {
            underline: {
                "&::after": {
                    borderBottomColor: "#777777",
                    borderBottom: "2px solid #777777 !important"
                }
            },
        },
        MuiFormControl: {
            root: {
                marginLeft: "2px",
                marginRight: "5px",
                marginTop: "20px"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: false,
            siblingsDialog: false,
            addEditDialog: false,
            shop_id: 2,
            allData: null
        }
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    componentDidMount() {
        const { user } = toJS(this.props.internal)

        this.setState({shop_id: Number(this.props.match.params.idShop)})

        if(user && user.data && user.data.permissions && user.data.permissions.lists_banners && user.data.permissions.lists_banners.view) {
            // this.loadBanners();
            this.setPermmissions()
            this.props.internal.setRoute(this.props.history, this.props.location.pathname);
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.BANNER);
            // this.addQueryToUrl("shop_id", "1");
            this.loadBanners()
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    componentWillReceiveProps() {
        if(Number(this.props.match.params.idShop) !== this.state.shop_id) {
            this.setState({shop_id: Number(this.props.match.params.idShop), loadingPage: true})
            this.loadBanners()
        }
    }

    setPermmissions () {
        const { user } = toJS(this.props.internal)

        if(user && user.data && user.data.permissions && user.data.permissions.lists_banners ) {
            if( user.data.permissions.lists_banners.update) {
                this.dropDownMenuItems.push(
                    {
                        title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
                        action: "edit"
                    },
                )
            }

            if( user.data.permissions.lists_banners.destroy) {
                this.dropDownMenuItems.push(
                    {
                        title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                        action: "delete"
                    },
                )
            }
        }
    }

    loadBanners = async (size = 10, page = 0, searchterm = "", by = "name", dir = "asc") => {

        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }
        
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        let params = {
            searchterm: searchterm,
            page:{
                number:page,
                size:size,
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ],
        }

        let shop_id = "";
        let filters = {};

        shop_id = Number(this.props.match.params.idShop)
        filters.shop_id = shop_id
        params.filters = filters

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }

            if(queries.shop_id) {
                shop_id = queries.shop_id;
                filters.shop_id = shop_id
                params.filters = filters
            }
        }

        let load_data = await api({
            method:'get',
            url: 'lists/banners',
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({allData: load_data.data})
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
        
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        searchTerm = removeAccents(searchTerm).toLowerCase()

        const { data } = this.state.allData

        let result = data.filter(item => removeAccents(item.title).toLowerCase().includes(searchTerm))
        this.props.internal.setResultDataForTable(result)
        
        if(searchTerm === '') {
            this.props.internal.setResultDataForTable(this.state.allData.data)
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadBanners()
    }

    handleDelete = async () => {
        let idBanner = toJS(this.props.internal.actionDeleteObj.id)
        let delete_banner = await api({
            method: 'delete',
            url: `lists/banners/${idBanner}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_banner.success === true) {
            this.props.internal.setSnackbar(delete_banner.data.message, true)
            this.loadBanners();
            this.props.internal.setActionDelete();
        }
    }

    tableHeader = [
        {
            "title": "title",
            "numeric": false,
            "min_width": "150px",
            
        },
        // {
        //     "title": "description",
        //     "numeric": false,
        //     "min_width": "150px"
        // },
        // {
        //     "title": "url",
        //     "numeric": false,
        //     "min_width": "150px"
        // },
        // {
        //     "title": "button_name",
        //     "numeric": false,
        //     "min_width": "100px"
        // },
        {
            "title": "published_from",
            "numeric": false,
            "min_width": "100px"
        },
        {
            "title": "published_until",
            "numeric": false,
            "min_width": "100px"
        },
        {
            "title": "active",
            "numeric": false,
            textAlign: "center"
        },
        {
            "title": "position",
            "numeric": false,
            "textAlign": "center"
        }
    ];
    tableBody = [
        "title",
        // "",
        // "",
        // "",
        "published_from",
        "published_until",
        "production",
        "id"
    ]

    dropDownMenuItems = [
        // {
        //     title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
        //     action: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // },
    ];

    closeDialogChangePosition = () => {
        this.setState({siblingsDialog: false})
        this.loadBanners();
    }

    openDialogChangePosition = () => {
        this.setState({siblingsDialog: true})
    }

    //dialog pre vytvorenie/upravenie polozky menu
    handleOpenCloseDialog = () => {
        let actionEdit = toJS(this.props.internal.actionEdit)
        if(actionEdit.edit) {
            actionEdit = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEdit)
        }
        else {
            this.setState({addEditDialog: false})
        }
        this.loadBanners()
    }

    clickOnProductionStatus = async(id, status) => {
        let update_data = await api({
            method: "patch",
            url: `lists/banners/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                production: status
            }
        });

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message,true)
            this.loadBanners()
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message,true)
        }
    }

    handleOpenDialog = () => {
        this.setState({addEditDialog: true})
        
    }

    handleChangeShop = shop_id => {
        this.setState({shop_id: shop_id.target.value})
        this.addQueryToUrl("shop_id", shop_id.target.value)
    }

    render () {
        const { user } = toJS(this.props.internal)
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'banner'}>
                    {/* zmena poradia prvkov v menu */}
                    <ChangeSiblingsPositions
                        open={this.state.siblingsDialog}
                        onClose={this.closeDialogChangePosition}
                        title={this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CHANGE_SIBLINGS_POSITIONS}
                        childs={this.props.internal.dataForTable.data}
                    />
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.BANNER.DELETE_BANNER_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />

                    {(this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)) &&
                        <AddEditItem
                            open={this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.state.addEditDialog ? this.props.translate.i18n.MODULES.BANNER.DIALOG_TITLE_CREATE : this.props.translate.i18n.MODULES.BANNER.DIALOG_TITLE_EDIT}
                            shop={this.state.shop_id}
                        />
                    }
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        {user.data.permissions.lists_banners.store ?
                            <CustomButton
                                mystyle = {'btn-orange-bg border-radius-18'}
                                title = {this.props.translate.i18n.MODULES.BANNER.CREATE_NEW_BANNER}
                                onClick = {this.handleOpenDialog}
                            >
                                <Icon path = {mdiPlus} size = {1}/>
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    {/* <MuiThemeProvider theme={materialTheme}>
                        <FormControl className="select-type-position">
                            <InputLabel
                                htmlFor="select-shop"
                                className={"label-select-type"}
                                // shrink={true}
                            >
                                {this.props.translate.i18n.MODULES.MENU.SHOP}
                            </InputLabel>
                            <Select
                                classes={{
                                    root: "select-menu-position-root",
                                }}
                                value={this.state.shop_id}
                                onChange={this.handleChangeShop}
                                inputProps={{
                                    name: "select-shop",
                                    id: "select-shop",
                                }}
                                // displayEmpty
                            >
                                {toJS(this.props.internal.dataForTable.lists.shops).map((shop, index) => {
                                    return (<MenuItem key={index} value={shop.id}>{shop.name}</MenuItem>);
                                })}
                            </Select>
                        </FormControl>
                    </MuiThemeProvider> */}
                    {this.state.loadingTable
                        ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/banner'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                            openDialogSiblings={this.openDialogChangePosition}
                            clickOnProductionStatus={this.clickOnProductionStatus}
                            disablePagination
                            disableSort
                        />
                    }
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/banner/Banner.jsx